<template>
    <div v-if="asyncDataStatus_ready">

    <v-row>
      <v-breadcrumbs :items="breadcrumbs" divider=">" style="padding: 12px">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="item.href"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="certificates.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'ClientsCertificatesNew', params: { childCompanyId: childCompanyId }})"
        >
          Dodaj certifikat
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="certificates.length">
      <v-col
        cols="12" md="6" lg="4" xl="3"
        v-for="item of filteredCertificates" :key="item.id"
      >
        <CertificateCard
          :certificate="item"
          :childCompanyId="childCompanyId"
          @edit="$router.push({name: 'ClientsCertificatesEdit', params: { childCompanyId: childCompanyId, certificateId: item.id}})"
          @delete="showDeleteCertificateModal = true; deleteCertificate = item"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje certifikata uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje certifikata"
      text="Ali ste prepričani, da želite izbrisati certifikat? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteCertificateModal"
      @confirmed="remove(deleteCertificate)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import ConfirmDialog from '@/components/ConfirmDialog'
import CertificateCard from '@/components/CertificateCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    CertificateCard
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      filter: '',
      showDeleteCertificateModal: false,
      deleteCertificate: null,
      breadcrumbs: [
        {
          text: 'Stranke',
          disabled: false,
          href: '/clients'
        },
        {
          text: 'Digitalno potrdilo',
          disabled: false,
          href: '/clients/' + this.childCompanyId + '/certificates'
        }
      ]
    }
  },
  computed: {
    certificates () {
      return objectToArray(this.$store.state.clientsCertificates.items)
    },
    filteredCertificates () {
      return this.certificates.filter(item => siIncludes({ haystack: `${item.name}`, needle: this.filter }))
    }
  },
  methods: {
    ...mapActions('clientsCertificates', ['loadItems', 'deleteItem']),
    remove (item) {
      this.deleteItem({ childCompanyId: this.childCompanyId, certificateId: item.id })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Element uspešno izbrisan.'
          }) */
        })
    }
  },
  created () {
    this.loadItems({ childCompanyId: this.childCompanyId })
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
